import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_5: FaireProductEntity = {
  token: "beverage-5",
  type: "product",
  name: "Sparkling Water Collection",
  brandName: "Craft Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c0ee2a474a3a944d25643290747265441da36bd4982aa3bdff84fdacba4dcf7b.webp",
  priceDollars: 20,
  msrpDollars: 32,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
